// extracted by mini-css-extract-plugin
export default {"wrapper":"UpdateTransaction_wrapper__NorCD","form":"UpdateTransaction_form__jWaYs","inputWrapper":"UpdateTransaction_inputWrapper__Vsp2J"};